import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const InstructorAuthContext = createContext(null);
export { InstructorAuthContext };

export const InstructorAuthProvider = ({ children }) => {
  const [instructor, setInstructor] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if instructor is logged in on mount
  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get('/instructor-auth/me');
      // 202 means application was just approved — ask user to log in again to get full token
      if (res.reloginRequired) {
        setInstructor({ reloginRequired: true });
      } else {
        setInstructor(res.instructor);
      }
    } catch {
      setInstructor(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const res = await api.post('/instructor-auth/login', { email, password });
    setInstructor(res.instructor);
    return res;
  };

  const logout = async () => {
    try {
      await api.post('/instructor-auth/logout');
    } catch {
      // ignore
    }
    setInstructor(null);
  };

  const refreshProfile = async () => {
    try {
      const res = await api.get('/instructor-auth/me');
      setInstructor(res.instructor);
    } catch {
      // ignore
    }
  };

  return (
    <InstructorAuthContext.Provider value={{ instructor, loading, login, logout, refreshProfile, checkAuth }}>
      {children}
    </InstructorAuthContext.Provider>
  );
};

export const useInstructorAuth = () => {
  const ctx = useContext(InstructorAuthContext);
  if (!ctx) throw new Error('useInstructorAuth must be used within InstructorAuthProvider');
  return ctx;
};
